import { render, staticRenderFns } from "./WeetControlPlayer.vue?vue&type=template&id=2d040242&scoped=true"
import script from "./WeetControlPlayer.vue?vue&type=script&lang=ts"
export * from "./WeetControlPlayer.vue?vue&type=script&lang=ts"
import style0 from "./WeetControlPlayer.vue?vue&type=style&index=0&id=2d040242&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d040242",
  null
  
)

export default component.exports